import QnaQList from '@/pages/qna/QnaQList.vue';
import QnaAList from '@/pages/qna/QnaAList.vue';
import QnaCList from '@/pages/qna/QnaCList.vue';
import QnaQReportList from '@/pages/qna/QnaQReportList.vue';
import QnaAReportList from '@/pages/qna/QnaAReportList.vue';
import QnaCReportList from '@/pages/qna/QnaCReportList.vue';
import QnaUserReportList from '@/pages/qna/QnaUserReportList.vue';
import QnaReportDetail from '@/pages/qna/_type/QnaReportDetail.vue';
import QnaQRegister from '@/pages/qna/QnaQRegister.vue';
import QnaARegister from '@/pages/qna/QnaARegister.vue';
import QnaCRegister from '@/pages/qna/QnaCRegister.vue';
import QnaQDetail from '@/pages/qna/QnaQDetail.vue';
import QnaADetail from '@/pages/qna/QnaADetail.vue';
import QnaCDetail from '@/pages/qna/QnaCDetail.vue';
import QnaRegisterBlock from '@/pages/qna/QnaRegisterBlock.vue';

export default {
	QnaQList: {
		id: 'QnaQList',
		path: '/qna/q/list',
		title: '질문 리스트',
		heading: '질문 리스트',
		type: 'v3',
		component: QnaQList,
	},
	QnaAList: {
		id: 'QnaAList',
		path: '/qna/a/list',
		title: '답변 리스트',
		heading: '답변 리스트',
		type: 'v3',
		component: QnaAList,
	},
	QnaCList: {
		id: 'QnaCList',
		path: '/qna/c/list',
		type: 'v3',
		title: '댓글 리스트',
		heading: '댓글 리스트',
		component: QnaCList,
	},
	QnaQReportList: {
		id: 'QnaQReportList',
		path: '/qna/q/report/list',
		type: 'v3',
		title: '질문 신고 목록',
		heading: '질문 신고 목록',
		component: QnaQReportList,
	},
	QnaAReportList: {
		id: 'QnaAReportList',
		path: '/qna/a/report/list',
		type: 'v3',
		title: '답변 신고 목록',
		heading: '답변 신고 목록',
		component: QnaAReportList,
	},
	QnaCReportList: {
		id: 'QnaCReportList',
		path: '/qna/c/report/list',
		type: 'v3',
		title: '댓글 신고 목록',
		heading: '댓글 신고 목록',
		component: QnaCReportList,
	},
	QnaUserReportList: {
		id: 'QnaUserReportList',
		path: '/qna/user/report/list',
		type: 'v3',
		title: '회원 신고 목록',
		heading: '회원 신고 목록',
		component: QnaUserReportList,
	},
	QnaReportDetail: {
		id: 'QnaReportDetail',
		path: '/qna/:_type/report/:_id',
		title: '신고 상세정보',
		component: QnaReportDetail,
		type: 'v3',
	},
	QnaQRegister: {
		id: 'QnaQRegister',
		heading: '질문 등록',
		title: '질문 등록',
		path: '/qna/q',
		component: QnaQRegister,
	},
	QnaARegister: {
		id: 'QnaARegister',
		heading: '답변 등록',
		title: '답변 등록',
		path: '/qna/q/:_id/a',
		component: QnaARegister,
	},
	QnaCRegister: {
		id: 'QnaCRegister',
		heading: '댓글 등록',
		title: '댓글 등록',
		path: '/qna/a/:_id/c',
		component: QnaCRegister,
	},
	QnaQDetail: {
		id: 'QnaQDetail',
		path: '/qna/q/:_id',
		title: '질문 상세조회',
		heading: '질문 상세조회',
		type: 'v3',
		component: QnaQDetail,
	},
	QnaADetail: {
		id: 'QnaADetail',
		path: '/qna/a/:_id',
		title: '답변 상세조회',
		type: 'v3',
		heading: '답변 상세정보',
		component: QnaADetail,
	},
	QnaCDetail: {
		id: 'QnaCDetail',
		path: '/qna/c/:_id',
		title: '댓글 상세조회',
		type: 'v3',
		heading: '댓글 상세정보',
		component: QnaCDetail,
	},
	QnaRegisterBlock: {
		id: 'QnaRegisterBlock',
		path: '/qna/register-block',
		title: 'QnA 작성자 차단 이력',
		heading: '작성자 차단 이력',
		component: QnaRegisterBlock,
		type: 'v3',
	},
};
